import { useQuery } from "@tanstack/react-query";
import type { SellerFreeShippingRuleView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseFreeShippingRulesQueryParams = {
  storeSlug: string;
};

export function useFreeShippingRulesQuery({ storeSlug }: UseFreeShippingRulesQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.seller.freeShippingRules(storeSlug),
    queryFn: () =>
      apiJsonClient<SellerFreeShippingRuleView[]>(endpoints.seller.storeFreeShippingRules, {
        cache: "no-store",
      }),
    enabled: storeSlug.length > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
  };
}
